<div class="vc-patients vc-view-shell">
  <main class="vc-patients__layout vc-view-content">
    <section class="vc-patients__frame vc-surface-panel">
      <div class="vc-page-toolbar vc-patients__toolbar vc-patients__toolbar--desktop">
        <div class="vc-page-toolbar__group vc-page-toolbar__group--grow">
          <div class="vc-patients__filter-group vc-patients__filter-group--search">
            <span class="p-input-icon-left">
              <i class="fas fa-search"></i>
              <input
                pInputText
                type="text"
                [(ngModel)]="searchText"
                (ngModelChange)="onSearchChange()"
                [placeholder]="'ADMIN.PATIENTS.SEARCH' | translate"
              />
            </span>
            <button
              class="vc-patients__search-clear"
              *ngIf="searchText"
              (click)="clearSearch()"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div class="vc-page-toolbar__group">
          <label class="vc-patients__filter-check">
            <p-checkbox
              [(ngModel)]="filterIncomplete"
              [binary]="true"
              (onChange)="onFilterChange()"
            ></p-checkbox>
            <span>{{ "ADMIN.PATIENTS.FILTER.INCOMPLETE" | translate }}</span>
          </label>
        </div>

        <div class="vc-page-toolbar__group vc-page-toolbar__meta">
          <div class="vc-patients__filter-count">
            <span class="vc-patients__count-value">{{ filteredCount }}</span>
            <span class="vc-patients__count-label">{{ "ADMIN.PATIENTS.COUNT" | translate }}</span>
          </div>
        </div>

        <div class="vc-page-toolbar__group">
          <button
            pButton
            class="p-button-primary p-button-sm"
            (click)="openCreatePatient()"
            *ngIf="hasPermission('PATIENTS.CREATE')"
          >
            <i class="fas fa-plus"></i>
            <span>{{ "ADMIN.PATIENTS.ADD" | translate }}</span>
          </button>
        </div>
      </div>

      <div class="vc-page-toolbar vc-page-toolbar--stacked vc-patients__toolbar vc-patients__toolbar--mobile">
        <div class="vc-patients__mobile-filters">
          <div class="vc-patients__mobile-search">
            <i class="fas fa-search"></i>
            <input
              pInputText
              type="text"
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange()"
              [placeholder]="'ADMIN.PATIENTS.SEARCH' | translate"
            />
            <button
              class="vc-patients__mobile-search-clear"
              *ngIf="searchText"
              (click)="clearSearch()"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <button
            class="vc-patients__mobile-filter-btn"
            (click)="toggleMobileFilters()"
            [class.vc-patients__mobile-filter-btn--active]="showMobileFilters || filterIncomplete"
          >
            <i class="fas fa-sliders-h"></i>
            <span class="vc-patients__filter-indicator" *ngIf="filterIncomplete"></span>
          </button>
        </div>

        <div class="vc-patients__mobile-filter-panel" *ngIf="showMobileFilters">
          <label class="vc-patients__mobile-check">
            <p-checkbox
              [(ngModel)]="filterIncomplete"
              [binary]="true"
              (onChange)="onFilterChange()"
            ></p-checkbox>
            <span>{{ "ADMIN.PATIENTS.FILTER.INCOMPLETE" | translate }}</span>
          </label>

          <div class="vc-page-toolbar__meta vc-patients__mobile-meta">
            <span class="vc-patients__count-value">{{ filteredCount }}</span>
            <span class="vc-patients__count-label">{{ "ADMIN.PATIENTS.COUNT" | translate }}</span>
          </div>
        </div>
      </div>

      <!-- ==================== CONTENT ==================== -->
      <div class="vc-patients__content">
        <!-- Loading State -->
        <div class="vc-patients__loading" *ngIf="loading">
          <div class="vc-patients__skeleton" *ngFor="let i of [1, 2, 3, 4, 5]">
            <p-skeleton styleClass="vc-patients__skeleton-placeholder"></p-skeleton>
          </div>
        </div>

        <!-- Empty State -->
        <div class="vc-patients__empty" *ngIf="!loading && filteredPatients.length === 0">
          <i class="fas fa-users"></i>
          <h3>{{ "ADMIN.PATIENTS.NOTFOUND" | translate }}</h3>
          <p>{{ "ADMIN.PATIENTS.EMPTY_DESCRIPTION" | translate }}</p>
        </div>

        <!-- Desktop Table -->
        <div
          class="vc-patients__table-container"
          *ngIf="!loading && filteredPatients.length > 0 && !isMobile"
        >
          <p-table
            #dt
            [value]="filteredPatients"
            [paginator]="true"
            [first]="tableFirst"
            [rows]="tableRows"
            [rowsPerPageOptions]="[20, 50, 100]"
            (onPage)="onTablePage($event)"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{{ 'COMMON.TABLE.PAGINATION' | translate }}"
            styleClass="p-datatable-sm"
            [tableStyle]="{ 'min-width': '100%' }"
            [sortField]="'fullName'"
            [sortOrder]="1"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="fullName">
                  {{ "COMMON.NAME" | translate }}
                  <p-sortIcon field="fullName"></p-sortIcon>
                </th>
                <th pSortableColumn="email">
                  {{ "COMMON.EMAIL" | translate }}
                  <p-sortIcon field="email"></p-sortIcon>
                </th>
                <th>{{ "COMMON.PHONE" | translate }}</th>
                <th class="text-center vc-patients__actions-column">
                  {{ "COMMON.ACTIONS" | translate }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-patient>
              <tr>
                <td>
                  <app-patient-link [patient]="patient"></app-patient-link>
                </td>
                <td>
                  <span class="vc-patients__email">{{ patient.email || '-' }}</span>
                </td>
                <td>
                  <span class="vc-patients__phone">{{ patient.phone || '-' }}</span>
                </td>
                <td class="text-center">
                  <div class="vc-patients__row-actions">
                    <button
                      pButton
                      class="p-button-text p-button-sm"
                      (click)="goToRecord(patient)"
                      pTooltip="{{ 'COMMON.PATIENT.RECORD' | translate }}"
                      tooltipPosition="bottom"
                    >
                      <i class="fas fa-info-circle"></i>
                    </button>
                    <button
                      pButton
                      class="p-button-text p-button-sm"
                      (click)="editPatient(patient)"
                      *ngIf="hasPermission('PATIENTS.UPDATE')"
                      pTooltip="{{ 'COMMON.EDIT' | translate }}"
                      tooltipPosition="bottom"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button
                      pButton
                      class="p-button-text p-button-sm p-button-danger"
                      (click)="confirmRemove(patient)"
                      *ngIf="hasPermission('PATIENTS.DELETE')"
                      pTooltip="{{ 'COMMON.DELETE' | translate }}"
                      tooltipPosition="bottom"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <!-- Mobile Cards -->
        <div
          class="vc-patients__cards"
          *ngIf="!loading && filteredPatients.length > 0 && isMobile"
        >
          <div class="vc-patients__card" *ngFor="let patient of paginatedPatients" (click)="goToRecord(patient)">
            <div class="vc-patients__card-main">
              <div class="vc-patients__card-info">
                <span class="vc-patients__card-fullname">{{ patient.fullName }}</span>
                <div class="vc-patients__card-details">
                  <span *ngIf="patient.email"><i class="fas fa-envelope"></i> {{ patient.email }}</span>
                  <span *ngIf="patient.phone"><i class="fas fa-phone"></i> {{ patient.phone }}</span>
                </div>
              </div>
              <div class="vc-patients__card-quick-actions" (click)="$event.stopPropagation()">
                <button
                  pButton
                  class="p-button-text p-button-sm"
                  (click)="editPatient(patient)"
                  *ngIf="hasPermission('PATIENTS.UPDATE')"
                >
                  <i class="fas fa-edit"></i>
                </button>
                <i class="fas fa-chevron-right vc-patients__card-arrow"></i>
              </div>
            </div>
          </div>

          <!-- Mobile Pagination -->
          <div class="vc-patients__mobile-pagination" *ngIf="totalMobilePages > 1">
            <button
              class="vc-patients__page-btn"
              [disabled]="currentMobilePage === 1"
              (click)="goToMobilePage(currentMobilePage - 1)"
            >
              <i class="fas fa-chevron-left"></i>
            </button>
            <span class="vc-patients__page-info">
              {{ currentMobilePage }} / {{ totalMobilePages }}
            </span>
            <button
              class="vc-patients__page-btn"
              [disabled]="currentMobilePage === totalMobilePages"
              (click)="goToMobilePage(currentMobilePage + 1)"
            >
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  </main>

  <!-- ==================== FAB - Mobile only ==================== -->
  <button
    class="vc-patients__fab"
    (click)="openCreatePatient()"
    *ngIf="hasPermission('PATIENTS.CREATE')"
    [attr.aria-label]="'ADMIN.PATIENTS.ADD' | translate"
  >
    <i class="fas fa-plus"></i>
  </button>
</div>

<p-menu #menu appendTo="body" [model]="menuOptions" [popup]="true"></p-menu>
